import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Header from '../../../../../../components/Stake/header';
import OmIcon from '../../../../../../assets/images/tokens/om.svg';
import stylesParent from '../../styles/frame/frame.module.scss';
import ContentError from '../../../../../../components/content-error';
import { initData } from '../../../../../../actions/delegator-reward-actions';
import { MERKLE_AIRDROP_NAMES } from '../../../../../../constants/blockchain-constants';

const Error = ({ setStatus }) => {
  const dispatch = useDispatch();
  const done = () => {
    dispatch(initData(MERKLE_AIRDROP_NAMES.MATIC));
  };

  return (
    <>
      <Header icon={OmIcon} title='OM Error' />
      <div className={stylesParent.cardContent}>
        <ContentError
          title="We can't see your transaction but it may still be mined."
          className={stylesParent.error}
        >
          If you have trouble claiming contact us in{' '}
          <a href='https://t.me/MANTRADAO' rel='noopener noreferrer' target='_blank'>
            Telegram
          </a>{' '}
          or send us an email at <a href='mailto:support@mantradao.com'>support@mantradao.com</a>{' '}
          with the relevant info about the issue. Try raising the gwei price of your Polygon
          transaction.
        </ContentError>
        <Button
          variant='contained'
          onClick={() => {
            done();
            setStatus(2);
          }}
          className={stylesParent.cardFooterControlsButton}
          color='secondary'
        >
          <span style={{ fontWeight: 800 }}>Done</span>
        </Button>
      </div>
    </>
  );
};

Error.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default Error;
